import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import { updateJointBillServiceProviderBillPlan } from "./services";
import { type IUpdateJointBillServiceProviderBillPlanRequest } from "./types";

export const useUpdateJointBillServiceProviderBillPlanMutation = (data?: {
  onSuccess?: () => void;
}) =>
  useMutation<void, Error, IUpdateJointBillServiceProviderBillPlanRequest>({
    mutationFn: updateJointBillServiceProviderBillPlan,
    onSuccess: async (_, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [
            "jointBillServiceProviderBillPlans",
            variables.jointBillServiceId,
          ],
        }),
        queryClient.invalidateQueries({
          queryKey: ["selectedJointBillServiceProviderBillPlans"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["budget"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["jointBillServicePeriodData"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["jointBillServiceSettings", variables.jointBillServiceId],
        }),
      ]);

      data?.onSuccess?.();
    },
  });
